import * as React from "react";

import "./style.scss";

// Component imports
import MasterForm from "./components/MasterForm";
import Hero, {
    IHeroProps,
    headerStyle
} from "src/components/Organisms/Hero/hero";

const heroProps: IHeroProps = {
    style: headerStyle(require("src/components/Organisms/images/banner/incorporation.jpg")),
    header: "SETUP YOUR COMPANY",
    subLine: "First step towards success to stay focus."
};

export default class IncorporationProcess extends React.Component<{
    type: string;
    paymentAmount: number;
}> {
    public render() {
        return (
            <div id="incorporation">
                <Hero {...heroProps} />
                <MasterForm type={this.props.type} paymentAmount={this.props.paymentAmount} />
            </div>
        );
    }
}
